import { useMutation, useQueryClient } from '@tanstack/react-query'
import { contactsApiService } from '@/services/contactsApi'
import { accountQueries } from '@/services/accountApi'
import type { ContactCreationRequest } from '@/services/contactsApi'

function invalidateContactCaches(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries({ queryKey: accountQueries.contactsLookupBase })
  queryClient.invalidateQueries({ queryKey: accountQueries.contactsBase })
  queryClient.invalidateQueries({ queryKey: accountQueries.contactsInfiniteBase })
  queryClient.invalidateQueries({ queryKey: accountQueries.contactLabelsBase })
}

export function useUpdateContact() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ contactId, payload }: { contactId: string; payload: Partial<ContactCreationRequest> }) =>
      contactsApiService.updateContact(contactId, payload),
    onSuccess: () => invalidateContactCaches(queryClient),
  })
}

export function useDeleteContact() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (contactId: string) => contactsApiService.deleteContact(contactId),
    onSuccess: () => invalidateContactCaches(queryClient),
  })
}
